import React, { Component } from "react";
import "../../css/FilterBarMobile.css";
import FilterBarModal from "./FilterBarModal";
import FilterButtonModal from "./FilterButtonModal";
import { connect } from "react-redux";
import { sortByFitler } from "../../models";
import { Translation } from "react-i18next";

let $ = window.$;

class FilterBarMobile extends Component {
  state = {
    showFilter: false,
    showSort: false
  };
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }
  handleScroll = () => {
    // 手機版本滾動事件
    if (document.body.offsetWidth > 767) {
      return;
    }
    const parentElement = $("#filter-sort-mobile-layout").offset();
    if (parentElement && window.pageYOffset + 65 > parentElement.top) {
      $("#filter-sort-mobile-wrap").css({
        position: "fixed",
        zIndex: "1001",
        top: "65px",
        left: "0",
        boxShadow: "0 5px 5px rgba(0, 0, 0, 0.1)"
      });
    } else {
      $("#filter-sort-mobile-wrap").css({
        position: "",
        zIndex: "",
        top: "",
        left: "",
        boxShadow: ""
      });
    }
  };
  handleFilter = () => {
    // 開啟篩選
    this.setState({
      showFilter: true
    });
  };
  closeFilter = () => {
    this.setState({
      showFilter: false
    });
  };
  handleSort = () => {
    // 開啟排序
    this.setState({
      showSort: true
    });
  };
  closeSort = () => {
    this.setState({
      showSort: false
    });
  };
  chooseSorting = data => {
    const { keywords, chosenFilterList } = this.props;
    this.props.updateSortBy(data, keywords, chosenFilterList);
    this.closeSort();
  };
  render() {
    const { productRefinements, sortByLists, activeSortBy, keywords, lang } =
      this.props;
    return (
      <div className="filter-sort-mobile-layout" id="filter-sort-mobile-layout">
        <div className="filter-sort-mobile-wrap" id="filter-sort-mobile-wrap">
          <div className="filter-mobile-btn" onClick={this.handleFilter}>
            <Translation>{t => <>{t("searchPage.filterBy")}</>}</Translation>
          </div>
          <div className="filter-mobile-btn" onClick={this.handleSort}>
            <Translation>{t => <>{t("searchPage.sortBy")}</>}</Translation>
          </div>
        </div>
        <FilterBarModal
          active={this.state.showFilter}
          closeModal={this.closeFilter.bind(this)}
          closeParentModal={this.closeFilter.bind(this)}
          title={
            <Translation>{t => <>{t("searchPage.filterBy")}</>}</Translation>
          }
          hidenFooter={false}
          keywords={keywords}
          content={
            productRefinements
              ? productRefinements.refinements.map((data, index) =>
                  data.categoryCode === "CATEGORY" ? null : (
                    <FilterButtonModal
                      data={data}
                      key={index}
                      closeParentModal={this.closeFilter.bind(this)}
                      keywords={keywords}
                    />
                  )
                )
              : null
          }
        />
        <FilterBarModal
          active={this.state.showSort}
          closeModal={this.closeSort.bind(this)}
          closeParentModal={this.closeSort.bind(this)}
          title={
            <Translation>{t => <>{t("searchPage.sortBy")}</>}</Translation>
          }
          hidenFooter={true}
          keywords={keywords}
          content={sortByLists.map((data, index) => (
            <div
              key={index}
              className="filter-button-option"
              onClick={this.chooseSorting.bind(this, data)}
            >
              <span
                style={{
                  fontWeight: activeSortBy.name === data.name ? "bold" : ""
                }}
              >
                {lang === "en" ? data.name_en : data.name}
              </span>
            </div>
          ))}
        />
      </div>
    );
  }
}

FilterBarMobile.defaultProps = {
  keywords: ""
};

const mapStateToProps = state => {
  return {
    chosenFilterList: state.chosenFilter.chosenFilterList,
    productRefinements: state.searchKeywords.productRefinements,
    activeSortBy: state.sortByFilter.activeSortBy,
    sortByLists: state.sortByFilter.sortByLists
  };
};

const mapDispatchToProps = () => {
  return {
    updateSortBy: (data, keywords, chosenFilterList) =>
      sortByFitler.actions.updateSortBy(data, keywords, chosenFilterList)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterBarMobile);
